export default __webpack_public_path__ + "static/media/cloud9-2.5f3ac11c.png";